import { OrderRulesDashboardResponse, OrderRulesFilterParams } from './types';

// ─── Deprecated: kept for any residual callers ────────────────────────────────

/** @deprecated Use the individual per-tab fetch functions instead. */
export const fetchOrderRulesDashboard = async (
  _params: OrderRulesFilterParams = {},
): Promise<OrderRulesDashboardResponse> => {
  // Returning an empty shell so any lingering direct calls don't crash the UI
  // while the component migrates to per-tab fetches.
  return {
    lastRefreshedAt: '',
    kpis: [],
    regionBars: [],
    skuRecommendationSummary: [],
    maxPotentialExecution: [],
    enrollmentTrend: [],
    layerPerformanceTrend: [],
    executionSummary: [],
    recommendations: [],
    openRecommendations: [],
    salesDetails: [],
    customerUtilization: [],
    skuUtilization: [],
    maxPotential: [],
    maxPotentialNoLayer: [],
    orderRulesCheckBuild: [],
    orderRulesCheckCrossdock: [],
  };
};
